import { connect } from 'react-redux';
// import { isShareForecast, isPublicScoresView } from '@selectors/location';

import AppHeader from './AppHeader';

export const mapStateToProps = (state) => ({
  // shareMode: isShareForecast(state) || isPublicScoresView(state),
  // forcing shareMode to false since it is not used in mundialito
  shareMode: false,
});

export default connect(mapStateToProps)(AppHeader);
